import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CUEServiceBase, LiveServiceFileCollection, LiveServiceFormDataBase } from './cue-base.service';
import { CUEServiceListViewBase as CUEServiceListView } from '../_shared/base.management.component';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class SelfieCamService extends CUEServiceBase<SelfieCamFormData, SelfieCamListView> {
  constructor(http: HttpClient, jwtTokenService: JWTTokenService) {
    super(http, 'selfie-cam', jwtTokenService);
  }

  public getServiceDisplayName(): string {
    return 'Selfie Cam';
  }

  public listFrames(): Observable<Frame[]> {
    return this.CachedHttpGet('selfie-cam/filters');
  }
}

export interface Frame {
  backgroundPngUrl: string;
  image1X: number;
  image1Y: number;
  image1Width: number;
  image1Height: number;
  image2X: number;
  image2Y: number;
  image2Width: number;
  image2Height: number;
  labelX: number;
  labelY: number;
  labelFont: string;
  labelFontSize: number;
  labelJustification: LabelJustification;
  name: string;
}

export enum LabelJustification {
  Left = 'left',
  Right = 'right',
  Centered = 'centered'
}

export enum AddSelfieCamTo {
  lightshow = 1,
  customMp3 = 2
}

export interface Filter {
  name: string;
  url: string;
}

export class SelfieCamFormData implements LiveServiceFormDataBase {
  bottomImageUrl: string;
  duration: number;
  filterJson: string;
  titleText: string;
  shareText: string;
  name: string;
  startDate: string;
  endDate: string;
  selectedFilterIndex: number;
  embedMusic: boolean;
  embedMp3Url: string;
  embedPosition: number;
  couponId: number;
  forwardingTitle: string;
  forwardingBody: string;
  useAudible: boolean;
  regenerateAudio: boolean;
  insertionPattern: string;
  dateCreated: Date;
  serviceFiles: SelfieCamServiceFileCollection;
}

export class SelfieCamServiceFileCollection implements LiveServiceFileCollection {
  files: SelfieCamServiceFile[];

  constructor() {

    this.files = [];
  }

  public addBottomImageFile(file: File) {

    if (file) {

      const bottomImageIndex = this.files?.findIndex(f => f.fileType === SelfieCamFileType.Image);

      if (bottomImageIndex > -1) {

        this.files[bottomImageIndex].file = file;

      } else {

        this.files?.push({ file, fileType: SelfieCamFileType.Image });
      }
    }
  }

  public addAudio(file: File) {

    if (file) {

      const trackFileIndex = this.files?.findIndex(f => f.fileType === SelfieCamFileType.Audio);

      if (trackFileIndex > -1) {

        this.files[trackFileIndex].file = file;

      } else {

        this.files?.push({ file, fileType: SelfieCamFileType.Audio});

      }
    }
  }
}

export class SelfieCamServiceFile {
  file: File;
  fileType: SelfieCamFileType;
}

export enum SelfieCamFileType {
  Image,
  Audio,
  Filter
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SelfieCamListView extends CUEServiceListView {
}
